module.exports = __webpack_public_path__ + "img/delivery-light.e5aaf2a1.svg";